import { withInstall } from '@jdesign-vue/utils'

import InputTag from './src/input-tag.vue'

export const JdInputTag = withInstall(InputTag)
export default JdInputTag

export * from './src/input-tag'
